import dynamic from 'next/dynamic'

import { Loading } from 'common/widgets'


export default dynamic(() => import('./Cart'), { ssr: false, loading: () => <Loading isLoading fontSize={48} /> })
